import React from "react";
import { Button, Grid, TextField, Typography } from "@material-ui/core";
import { Formik } from "formik";
import * as Yup from "yup";
import AuthService from "../../../services/auth.service";
import Folder from "@material-ui/icons/Folder";
import IconButton from "@material-ui/core/IconButton";
import { useAlert } from "react-alert";
import PulseLoader from "react-spinners/PulseLoader";
import { colors } from "../../../assets/theme";
import { constantsApp } from "../../../constants/constants.app";

const SUPPORTED_FORMATS = ["image/jpg", "image/jpeg", "image/gif", "image/png"];

const communitySchema = Yup.object().shape({
  email: Yup.string()
    .email(
      constantsApp.components.forms.community.community.communitySchema
        .INVALID_EMAIL
    )
    .required(
      constantsApp.components.forms.community.community.communitySchema.REQUIRED
    ),
  password: Yup.string()
    .min(6)
    .required(
      constantsApp.components.forms.community.community.communitySchema.REQUIRED
    ),
  name: Yup.string().required(
    constantsApp.components.forms.community.community.communitySchema.REQUIRED
  ),
  address: Yup.string().required(
    constantsApp.components.forms.community.community.communitySchema.REQUIRED
  ),
  lat: Yup.number().required(
    constantsApp.components.forms.community.community.communitySchema.REQUIRED
  ),
  long: Yup.number().required(
    constantsApp.components.forms.community.community.communitySchema.REQUIRED
  ),
  maxHeight: Yup.number().required(
    constantsApp.components.forms.community.community.communitySchema.REQUIRED
  ),
  imageUrl: Yup.mixed()
    .required(
      constantsApp.components.forms.community.community.communitySchema.REQUIRED
    )
    .test(
      "fileFormat",
      constantsApp.components.forms.community.community.communitySchema
        .UNSUPPORTED_FORMAT,
      value => value && SUPPORTED_FORMATS.includes(value.type)
    )
});

const initialValues = {
  email: "",
  password: "",
  name: "",
  address: "",
  lat: "",
  long: "",
  role: "community",
  maxHeight: "",
  imageUrl: ""
};

export default function CreateForm({ onCancel }) {
  const alert = useAlert();
  return (
    <Formik
      initialValues={initialValues}
      validationSchema={communitySchema}
      onSubmit={(values, { setSubmitting, resetForm }) => {
        AuthService.createUser(values)
          .then(community => {
            resetForm(initialValues);
            setSubmitting(false);
            alert.show("Registro exitoso!", { type: "success" });
          })
          .catch(err => {
            setSubmitting(false);
            alert.show(err.message, { type: "error" });
          });
      }}
    >
      {({
        errors,
        handleChange,
        handleSubmit,
        values,
        setFieldValue,
        isSubmitting
      }) => {
        if (isSubmitting)
          return (
            <Grid
              container
              justify="center"
              alignItems="center"
              style={{ height: 200 }}
            >
              <PulseLoader color={colors.LOADING} />
            </Grid>
          );
        return (
          <form onSubmit={handleSubmit}>
            <Grid item>
              <Grid
                container
                style={{
                  alignItems: "center"
                }}
              >
                <input
                  onChange={event => {
                    setFieldValue("imageUrl", event.currentTarget.files[0]);
                  }}
                  id="imageUrl"
                  type="file"
                  style={{ display: "none" }}
                />
                <Typography variant="h5" color="secondary">
                  {values.imageUrl !== ""
                    ? values.imageUrl.name
                    : constantsApp.components.forms.community.community
                        .textField.UPLOAD_FILE}
                </Typography>
                <label htmlFor="imageUrl">
                  <IconButton color="secondary" component="span">
                    <Folder />
                  </IconButton>
                </label>
              </Grid>
              {errors && errors.imageUrl}
            </Grid>
            <TextField
              id="email"
              onChange={handleChange}
              value={values.email}
              variant="outlined"
              margin="dense"
              fullWidth
              type="email"
              label={
                constantsApp.components.forms.community.community.textField
                  .EMAIL_LBL
              }
              helperText={errors && errors.email}
            />
            <TextField
              id="password"
              onChange={handleChange}
              value={values.password}
              variant="outlined"
              margin="dense"
              fullWidth
              type="password"
              label={
                constantsApp.components.forms.community.community.textField
                  .PASSWORD_LBL
              }
              helperText={errors && errors.password}
            />
            <TextField
              id="name"
              onChange={handleChange}
              value={values.name}
              variant="outlined"
              margin="dense"
              fullWidth
              type="text"
              label={
                constantsApp.components.forms.community.community.textField
                  .NAME_LBL
              }
              helperText={errors && errors.name}
            />
            <TextField
              id="address"
              onChange={handleChange}
              value={values.address}
              variant="outlined"
              margin="dense"
              fullWidth
              type="text"
              label={
                constantsApp.components.forms.community.community.textField
                  .ADDRESS_LBL
              }
              helperText={errors && errors.address}
            />
            <TextField
              id="lat"
              onChange={handleChange}
              value={values.lat}
              variant="outlined"
              margin="dense"
              fullWidth
              type="number"
              label={
                constantsApp.components.forms.community.community.textField
                  .LATITUDE_LBL
              }
              helperText={errors && errors.lat}
            />
            <TextField
              id="long"
              onChange={handleChange}
              value={values.long}
              variant="outlined"
              margin="dense"
              fullWidth
              type="number"
              label={
                constantsApp.components.forms.community.community.textField
                  .LONGITUDE_LBL
              }
              helperText={errors && errors.long}
            />
            <TextField
              id="maxHeight"
              onChange={handleChange}
              value={values.maxHeight}
              variant="outlined"
              margin="dense"
              fullWidth
              type="number"
              label={
                constantsApp.components.forms.community.community.textField
                  .MAX_HEIGHT_LBL
              }
              helperText={errors && errors.maxHeight}
            />
            <Grid container justify="center">
              <Button
                onClick={() => {
                  onCancel("showForm");
                  onCancel("showFormCommunity");
                }}
                variant="contained"
                color="secondary"
                size="large"
              >
                {constantsApp.butons.CANCEL}
              </Button>
              <Button
                type="submit"
                variant="contained"
                color="secondary"
                size="large"
              >
                {constantsApp.butons.DONE}
              </Button>
            </Grid>
          </form>
        );
      }}
    </Formik>
  );
}
